import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface VersionData {
  version: string;
  clientId: string;
  tenantId: string;
  rumId?: string;
  rumPoolId?: string;
  rumRegion?: string;
  gaId?: string;
}

@Injectable()
export class VersionService {
  constructor(private httpClient: HttpClient) {}

  getVersion() {
    if (environment.localVersionData) {
      return of(environment.localVersionData as VersionData);
    }

    return this.httpClient.get<VersionData>('/rest/version').pipe(
      catchError((error) => {
        if (environment.localVersionData) {
          return of(environment.localVersionData as VersionData);
        }

        throw error;
      })
    );
  }
}
